module.exports = __webpack_public_path__ + "static/media/bg_hz.22f52869.png";